import { useEffect, useState } from 'react';
import { SITE_BRANDING_UPDATED_EVENT } from '../utils/siteBranding';
import { CONTACT_CHANNELS_UPDATED_EVENT } from '../utils/whatsappContact';
import {
  getPublicSiteEmail,
  getPublicSitePhoneDisplay,
  getPublicSocialLinks,
} from '../utils/publicContactInfo';

/** Live phone/email for Contact + Footer (updates when admin saves settings or contact channels). */
export default function usePublicContactDisplay() {
  const [, setTick] = useState(0);

  useEffect(() => {
    const bump = () => setTick((t) => t + 1);
    window.addEventListener(SITE_BRANDING_UPDATED_EVENT, bump);
    window.addEventListener(CONTACT_CHANNELS_UPDATED_EVENT, bump);
    window.addEventListener('storage', bump);
    return () => {
      window.removeEventListener(SITE_BRANDING_UPDATED_EVENT, bump);
      window.removeEventListener(CONTACT_CHANNELS_UPDATED_EVENT, bump);
      window.removeEventListener('storage', bump);
    };
  }, []);

  return {
    phoneDisplay: getPublicSitePhoneDisplay(),
    email: getPublicSiteEmail(),
    socialLinks: getPublicSocialLinks(),
  };
}
